import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Govconsoft provides software solutions and IT services tailored for government agencies." 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Govconsoft · Empowering Government Technology</p>
        <h1>Transforming Government Services with Innovative Technology</h1>
        <p className="lede">
          At Govconsoft, we specialize in delivering cutting-edge software solutions and IT services designed specifically for government agencies. Our mission is to enhance operational efficiency and improve public service delivery through technology.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Solutions
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Rapid Deployment</h2>
          <p>
            Our solutions are designed for quick implementation, ensuring that your agency can start benefiting from advanced technology without delay.
          </p>
        </article>
        <article>
          <h2>Tailored Solutions</h2>
          <p>
            We work closely with government agencies to customize our offerings, ensuring that your unique needs are met with precision and care.
          </p>
        </article>
        <article>
          <h2>Continuous Support</h2>
          <p>
            Our dedicated team provides ongoing support and maintenance, allowing your agency to focus on serving the public while we handle the technology.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;